import React from 'react';

const COLORS = [
  '#EF4444',
  '#F97316',
  '#F59E0B',
  '#22C55E',
  '#06B6D4',
  '#3B82F6',
  '#6366F1',
  '#8B5CF6',
  '#EC4899',
  '#94A3B8'
];

function ColorPicker({ value, onChange }) {
  return (
    <div className="color-picker">
      {COLORS.map((color) => (
        <button
          key={color}
          type="button"
          className={`color-swatch ${value === color ? 'active' : ''}`}
          style={{ backgroundColor: color }}
          onClick={() => onChange(color)}
          aria-label={`Select ${color}`}
        />
      ))}
    </div>
  );
}

export default ColorPicker;
